export default {
  brand: {
    name: "Mysore Yellow Pages",
    tagline: "Your hyperlocal business directory for Mysore & beyond",
  },
  nav: {
    directory: "Directory",
    categories: "Categories",
    locations: "Locations",
    touristSpots: "Tourist Spots",
    plans: "Plans",
    emergency: "Emergency",
    login: "Login",
    register: "Register",
    listBusiness: "List Business",
  },
  common: {
    search: "Search",
    viewAll: "View all",
    call: "Call",
    details: "Details",
    openNow: "Open now",
    closed: "Closed",
    featured: "Featured",
    verified: "Verified",
  },
};